(function () {
  function init() {
    var header = document.querySelector("[data-qr-header]");
    if (!header || header.dataset.qrInit) return;
    header.dataset.qrInit = "true";

    if (window.gsap) {
      gsap.fromTo(header, { y: -40, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: "power4.out" });
    }

    function onScroll() {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    var burger = header.querySelector("[data-qr-burger]");
    var mobileMenu = header.querySelector("[data-qr-mobile-menu]");
    if (burger && mobileMenu) {
      burger.addEventListener("click", function () {
        var isOpen = burger.classList.toggle("is-open");
        mobileMenu.hidden = !isOpen;
      });
      mobileMenu.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", function () {
          burger.classList.remove("is-open");
          mobileMenu.hidden = true;
        });
      });
    }
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
